import React from "react";

const CheckboxGroup = ({ id, label, value, onChange, options }) => {
  const handleChange = (e) => {
    const selectedOption = e.target.value;
    onChange([selectedOption]); // Only allow one selected value at a time
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="mt-1 flex flex-wrap gap-4">
        {options.map((option, index) => (
          <div key={index} className="flex items-center">
            <input
              id={`${id}-${index}`}
              name={id}
              type="checkbox"
              value={option}
              checked={value.includes(option)}
              onChange={handleChange}
              className="h-6 w-6 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label htmlFor={`${id}-${index}`} className="ml-2 block text-sm text-gray-900">
              {option}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;